import { getRootPluaralTranslator } from '@utils/get-module-translator'

const __rootTc = getRootPluaralTranslator()

export const requesterEmailField = () => {
  return {
    id: 5,
    type: 'SystemFieldRest',
    isSystemField: true,
    // refactor requester_email to requester
    paramName: 'requester',
    inputType: 'requester',
    guid: 'ef44f47a-7f88-409c-a7a0-f18d53ccf6cb',
    title: __rootTc('requester'),
    order: 2,
    required: true,
    useOnPortal: true,
    requesterRequired: true,
    sectionId: 0,
    canDelete: false,
    canUpdate: true,
    stage: '__vue_devtool_undefined__',
    percentageField: '__vue_devtool_undefined__',
    hidden: false,
  }
}

export const requesterField = () => {
  return {
    id: 5,
    type: 'SystemFieldRest',
    isSystemField: true,
    // refactor requester_email to requester
    paramName: 'requesterId',
    inputType: 'requesterid',
    guid: 'ef44f47a-7f88-409c-a7a0-f18d53ccf6cb',
    title: __rootTc('requester'),
    order: 2,
    required: true,
    useOnPortal: true,
    requesterRequired: true,
    sectionId: 0,
    canDelete: false,
    canUpdate: true,
    stage: '__vue_devtool_undefined__',
    percentageField: '__vue_devtool_undefined__',
    hidden: false,
  }
}

export const requestStatusField = () => {
  return {
    id: 99999,
    moduleName: 'request',
    type: 'SystemFieldRest',
    isSystemField: true,
    paramName: 'statusId',
    inputType: 'status',
    guid: '1fb3b5dc-4808-478c-b720-d4ddc708f4e8',
    title: 'Status',
    attributes: { widthClass: 'w-full', inputWidth: 40 },
    order: 6,
    required: false,
    markAsHidden: false,
    useOnPortal: false,
    requesterGroups: [],
    sectionId: 0,
    canDelete: false,
    canUpdate: false,
    requesterCanEdit: false,
    requesterRequired: false,
    hidden: false,
    fields: [],
  }
}

export const changeExteranSystemField = () => [
  {
    id: 999991,
    moduleName: 'change',
    type: 'SystemFieldRest',
    isSystemField: true,
    paramName: 'statusId',
    inputType: 'status',
    guid: '1fb3b5dc-4808-478c-b720-d4ddc708f4e8',
    title: 'Status',
    attributes: { widthClass: 'w-full', inputWidth: 40 },
    order: 6,
    required: false,
    markAsHidden: false,
    useOnPortal: false,
    requesterGroups: [],
    sectionId: 0,
    canDelete: false,
    canUpdate: false,
    requesterCanEdit: false,
    requesterRequired: false,
    hidden: false,
    fields: [],
  },
]

export const externalFormRulesQualificationsForAsset = () => [
  {
    displayName: __rootTc('asset_type'),
    key: 'assetTypeId',
    relOperatorsSupport: ['in', 'not_in'],
    hierarchical: true,
    primitiveType: 'long',
    inputTypes: 'assetType',
    operandType: 'VariableOperandRest',
    minHour: 0,
    maxHour: 0,
    group: 'asset_fields',
  },
  {
    displayName: __rootTc('name'),
    key: 'displayName',
    relOperatorsSupport: [
      'equal_case_insensitive',
      'not_equal_case_insensitive',
      'start_with',
      'end_with',
      'contains',
      'is_blank',
      'is_not_blank',
    ],
    hierarchical: false,
    primitiveType: 'string',
    inputTypes: 'text',
    operandType: 'PropertyOperandRest',
    group: 'asset_fields',
  },
  {
    displayName: `${__rootTc('managed_by')} ${__rootTc('group')}`,
    key: 'managedByGroupId',
    relOperatorsSupport: ['in', 'not_in'],
    hierarchical: true,
    primitiveType: 'long',
    inputTypes: 'technicianGroup',
    operandType: 'PropertyOperandRest',
    group: 'asset_fields',
  },
  {
    displayName: __rootTc('product'),
    key: 'productId',
    relOperatorsSupport: ['in', 'not_in'],
    hierarchical: false,
    primitiveType: 'long',
    inputTypes: 'product',
    operandType: 'PropertyOperandRest',
    group: 'asset_fields',
  },
  {
    displayName: __rootTc('managed_by'),
    key: 'managedById',
    relOperatorsSupport: ['in', 'not_in'],
    hierarchical: false,
    primitiveType: 'long',
    inputTypes: 'technician',
    operandType: 'PropertyOperandRest',
    group: 'asset_fields',
  },
  {
    displayName: __rootTc('department'),
    key: 'assignedDepartmentId',
    relOperatorsSupport: ['in', 'not_in'],
    hierarchical: true,
    primitiveType: 'long',
    inputTypes: 'department',
    operandType: 'PropertyOperandRest',
    group: 'asset_fields',
  },
  {
    displayName: __rootTc('location'),
    key: 'locationId',
    relOperatorsSupport: ['in', 'not_in'],
    hierarchical: false,
    primitiveType: 'long',
    inputTypes: 'location',
    operandType: 'PropertyOperandRest',
    group: 'asset_fields',
  },
  {
    displayName: __rootTc('asset_group'),
    key: 'assetGroupId',
    relOperatorsSupport: ['in', 'not_in'],
    hierarchical: true,
    primitiveType: 'long',
    inputTypes: 'assetGroup',
    operandType: 'PropertyOperandRest',
    group: 'asset_fields',
  },
  {
    displayName: __rootTc('used_by'),
    key: 'assignedUserIds',
    relOperatorsSupport: [
      'any_member_or_all_members_exist',
      'all_members_exist',
    ],
    hierarchical: false,
    primitiveType: 'array',
    inputTypes: 'requester',
    operandType: 'PropertyOperandRest',
    group: 'asset_fields',
  },
  {
    displayName: `${__rootTc('acquition')} ${__rootTc('date')}`,
    key: 'acquitionTime',
    relOperatorsSupport: [
      'equal',
      'greaterthan',
      'lessthan',
      'between',
      'before',
      'after',
      'exactly_next',
      'exactly_last',
      'within_next',
      'within_last',
      'between_next',
      'between_last',
    ],
    hierarchical: false,
    primitiveType: 'dateTime',
    inputTypes: 'dateTime',
    operandType: 'PropertyOperandRest',
    group: 'asset_fields',
  },
  {
    displayName: __rootTc('assignment_date'),
    key: 'assignmentTime',
    relOperatorsSupport: [
      'equal',
      'greaterthan',
      'lessthan',
      'between',
      'before',
      'after',
      'exactly_next',
      'exactly_last',
      'within_next',
      'within_last',
      'between_next',
      'between_last',
    ],
    hierarchical: false,
    primitiveType: 'dateTime',
    inputTypes: 'dateTime',
    operandType: 'PropertyOperandRest',
    group: 'asset_fields',
  },
  {
    displayName: __rootTc('status'),
    key: 'statusId',
    relOperatorsSupport: ['in', 'not_in'],
    hierarchical: false,
    primitiveType: 'long',
    inputTypes: 'status',
    operandType: 'PropertyOperandRest',
    group: 'asset_fields',
  },
  {
    displayName: __rootTc('impact'),
    key: 'impactId',
    relOperatorsSupport: ['in', 'not_in'],
    hierarchical: false,
    primitiveType: 'long',
    inputTypes: 'impact',
    operandType: 'PropertyOperandRest',
    group: 'asset_fields',
  },
  {
    displayName: __rootTc('category'),
    key: 'categoryId',
    relOperatorsSupport: ['in', 'not_in'],
    hierarchical: true,
    primitiveType: 'long',
    inputTypes: 'category',
    operandType: 'PropertyOperandRest',
    group: 'asset_fields',
  },
  {
    displayName: __rootTc('barcode'),
    key: 'barCode',
    relOperatorsSupport: [
      'equal_case_insensitive',
      'not_equal_case_insensitive',
      'start_with',
      'end_with',
      'contains',
      'is_blank',
      'is_not_blank',
    ],
    hierarchical: false,
    primitiveType: 'string',
    inputTypes: 'barcode',
    operandType: 'PropertyOperandRest',
    group: 'asset_fields',
  },
  {
    displayName: __rootTc('serial_number'),
    key: 'serialNumber',
    relOperatorsSupport: [
      'equal_case_insensitive',
      'not_equal_case_insensitive',
      'start_with',
      'end_with',
      'contains',
      'is_blank',
      'is_not_blank',
    ],
    hierarchical: false,
    primitiveType: 'string',
    inputTypes: 'text',
    operandType: 'PropertyOperandRest',
    group: 'asset_fields',
  },
  {
    displayName: __rootTc('ip_address'),
    key: 'ipAddress',
    relOperatorsSupport: [
      'equal_case_insensitive',
      'not_equal_case_insensitive',
      'start_with',
      'end_with',
      'contains',
      'is_blank',
      'is_not_blank',
    ],
    hierarchical: false,
    primitiveType: 'string',
    inputTypes: 'text',
    operandType: 'PropertyOperandRest',
    group: 'asset_fields',
  },
  {
    displayName: __rootTc('host_name'),
    key: 'hostName',
    relOperatorsSupport: [
      'equal_case_insensitive',
      'not_equal_case_insensitive',
      'start_with',
      'end_with',
      'contains',
      'is_blank',
      'is_not_blank',
    ],
    hierarchical: false,
    primitiveType: 'string',
    inputTypes: 'text',
    operandType: 'PropertyOperandRest',
    group: 'asset_fields',
  },
  {
    displayName: __rootTc('company'),
    key: 'companyId',
    relOperatorsSupport: ['in', 'not_in'],
    hierarchical: false,
    primitiveType: 'long',
    inputTypes: 'company',
    operandType: 'PropertyOperandRest',
    group: 'asset_fields',
  },
  {
    displayName: __rootTc('tag'),
    key: 'tags',
    relOperatorsSupport: [
      'any_member_or_all_members_exist',
      'all_members_exist',
    ],
    hierarchical: false,
    primitiveType: 'array',
    inputTypes: 'tags',
    operandType: 'PropertyOperandRest',
    group: 'asset_fields',
  },
]

export const assetExteranSystemField = () => [
  ...externalFormRulesQualificationsForAsset().map((field, idx) => ({
    id: 1000000 + idx,
    moduleName: 'asset',
    type: 'SystemFieldRest',
    isSystemField: true,
    paramName: field.key,
    inputType: field.inputTypes,
    guid: `asset-system-field-${field.key}`,
    title: field.displayName,
    attributes: { widthClass: 'w-full', inputWidth: 40 },
    order: 10 + idx,
    required: false,
    markAsHidden: false,
    useOnPortal: false,
    requesterGroups: [],
    sectionId: 0,
    canDelete: false,
    canUpdate: false,
    requesterCanEdit: false,
    requesterRequired: false,
    hidden: false,
    fields: [],
  })),
  {
    id: 99999999,
    moduleName: 'asset',
    type: 'SystemFieldRest',
    isSystemField: true,
    paramName: 'description',
    inputType: 'description',
    guid: '1fb3b5dc-4808-478c-b720-d4ddc708f4e8',
    title: __rootTc('description'),
    attributes: { widthClass: 'w-full', inputWidth: 40 },
    order: 10,
    required: false,
    markAsHidden: false,
    useOnPortal: false,
    requesterGroups: [],
    sectionId: 0,
    canDelete: false,
    canUpdate: false,
    requesterCanEdit: false,
    requesterRequired: false,
    hidden: false,
    fields: [],
  },
  {
    id: 99999991,
    moduleName: 'asset',
    type: 'SystemFieldRest',
    isSystemField: true,
    paramName: 'fileAttachments',
    inputType: 'fileAttachments',
    guid: '1fb3b5dc-4808-478c-b720-d4ddc708f4e8',
    title: __rootTc('attachment'),
    attributes: { widthClass: 'w-full', inputWidth: 40 },
    order: 11,
    required: false,
    markAsHidden: false,
    useOnPortal: false,
    requesterGroups: [],
    sectionId: 0,
    canDelete: false,
    canUpdate: false,
    requesterCanEdit: false,
    requesterRequired: false,
    hidden: false,
    fields: [],
  },
]

export const passwordConfirmPasswordSystemFiled = () => [
  {
    id: 9999999,
    moduleName: 'user',
    type: 'SystemFieldRest',
    isSystemField: true,
    paramName: 'password',
    inputType: 'password',
    guid: '13149ac5-209c-4274-a75c-a6c0c9af376e',
    title: 'Password',
    attributes: {
      widthClass: 'w-1/2',
      inputWidth: 100,
    },
    order: 2,
    required: true,
    markAsHidden: false,
    useOnPortal: false,
    requesterGroups: [],
    sectionId: 0,
    canDelete: false,
    canUpdate: true,
    requesterCanEdit: false,
    requesterRequired: true,
    hidden: false,
    fields: [],
  },
  {
    id: 99999999,
    moduleName: 'user',
    type: 'SystemFieldRest',
    isSystemField: true,
    paramName: 'confirmPassword',
    inputType: 'confirmPassword',
    guid: '13149ac5-209c-4274-a75c-a6c0c9af3780',
    title: 'Confirm Password',
    attributes: {
      widthClass: 'w-1/2',
      inputWidth: 100,
    },
    order: 2,
    required: true,
    markAsHidden: false,
    useOnPortal: false,
    requesterGroups: [],
    sectionId: 0,
    canDelete: false,
    canUpdate: true,
    requesterCanEdit: false,
    requesterRequired: true,
    hidden: false,
    fields: [],
  },
]

export const linkAssetIdsField = () => {
  return {
    id: 99934,
    moduleName: 'request',
    type: 'SystemFieldRest',
    isSystemField: true,
    paramName: 'linkAssetIds',
    inputType: 'linkAssetIds',
    guid: '1fb3b5dc-4808-478c-b720-d4ddc708f4e8',
    title: 'Link Asset',
    attributes: { widthClass: 'w-full', inputWidth: 40 },
    order: 6,
    required: false,
    markAsHidden: false,
    useOnPortal: false,
    requesterGroups: [],
    sectionId: 0,
    canDelete: false,
    canUpdate: false,
    requesterCanEdit: false,
    requesterRequired: false,
    hidden: false,
    fields: [],
  }
}

export const linkCiIdsField = () => {
  return {
    id: 99935,
    moduleName: 'request',
    type: 'SystemFieldRest',
    isSystemField: true,
    paramName: 'linkCiIds',
    inputType: 'linkCiIds',
    guid: '1fb3b5dc-4808-478c-b720-d4ddc708f4e8',
    title: 'Link CI',
    attributes: { widthClass: 'w-full', inputWidth: 40 },
    order: 6,
    required: false,
    markAsHidden: false,
    useOnPortal: false,
    requesterGroups: [],
    sectionId: 0,
    canDelete: false,
    canUpdate: false,
    requesterCanEdit: false,
    requesterRequired: false,
    hidden: false,
    fields: [],
  }
}
